// Tagalog: navigation menu, account chrome and role labels (field-facing screens). Keyed by the English source text.
export default {
  "Account": "Account",
  "Account menu": "Menu ng account",
  "Accounting": "Accounting",
  "Administration": "Administrasyon",
  "Assets": "Mga Asset",
  "Assets & Inventory": "Mga Asset at Imbentaryo",
  "Audit Scan": "Audit Scan",
  "Audit Schedules": "Mga Iskedyul ng Audit",
  "Audits": "Mga Audit",
  "Blind Counts": "Blind Count",
  "Blind Counts & Variance": "Blind Count at Variance",
  "Close": "Isara",
  "Coming in Phase 2": "Darating sa Phase 2",
  "Custody": "Custody",
  "Custody & Movements": "Custody at Paglipat",
  "Dashboard": "Dashboard",
  "Depreciation": "Depreciation",
  "Depreciation Runs": "Mga Depreciation Run",
  "Directory": "Direktoryo",
  "Disposals": "Mga Disposal",
  "Disposals & Write-Offs": "Disposal at Write-Off",
  "Home": "Home",
  "Incident Logging": "Pag-log ng Insidente",
  "Incidents": "Mga Insidente",
  "Integrations": "Mga Integrasyon",
  "Interface language": "Wika ng interface",
  "Inwarding": "Pagtanggap",
  "Inwarding & Tagging": "Pagtanggap at Pag-tag",
  "Language": "Wika",
  "Locations": "Mga Lokasyon",
  "Locations & Hierarchy": "Mga Lokasyon at Hierarchy",
  "Log In": "Mag-log In",
  "Log in": "Mag-log in",
  "Maintenance": "Maintenance",
  "Master Item Catalogue": "Master Item Catalogue",
  "More": "Iba pa",
  "Orders": "Mga Order",
  "Physical Verification": "Pisikal na Beripikasyon",
  "Plans": "Mga Plano",
  "Plans & Billing": "Mga Plano at Billing",
  "Properties": "Mga Property",
  "Reconcile": "I-reconcile",
  "Reconciliation Console": "Reconciliation Console",
  "Review billing": "Suriin ang billing",
  "Roles & Permissions": "Mga Role at Pahintulot",
  "Room Kit Stamping": "Room Kit Stamping",
  "Room Kits": "Mga Room Kit",
  "Scan": "I-scan",
  "Schedules": "Mga Iskedyul",
  "Security": "Seguridad",
  "Sign Out": "Mag-sign Out",
  "Sign out": "Mag-sign out",
  "Toggle navigation": "Ipakita/itago ang navigation",
  "User Directory": "Direktoryo ng User",
  "Work Orders": "Mga Work Order",
  "Admin": "Admin",
  "Customer Admin": "Customer Admin",
  "Property Manager": "Property Manager",
  "Finance Controller": "Finance Controller",
  "Auditor (read-only)": "Auditor (pagbasa lang)",
  "Field User": "Field User",
  "Storekeeper": "Storekeeper",
  "Department Head": "Department Head",
  "User": "User",
};
